import React from 'react';

const workExperience = [
  {
    title: 'Qubit - Co-founder & Lead Engineer',
    meta: 'May 2025 - Sep 2025 | Remote',
    bullets: [
      'Spearheaded the technical vision and full-stack development of the initial product MVP from ideation to launch.',
      'Architected and deployed a highly scalable Python-based backend API and managed the infrastructure lifecycle using Docker and cloud services.',
      'Managed product roadmap, set development priorities, and collaborated with co-founders on key strategic business decisions.',
    ],
  },
  {
    title: 'Kaedim - Full Stack Software Engineer',
    meta: 'Dec 2024 - Mar 2025 | San Francisco, CA',
    bullets: ['Developed end-to-end features in customer-facing and artist applications using MySQL, React.js, and Node.js.'],
  },
  {
    title: 'PathAI - Software Engineer Intern',
    meta: 'Jan 2023 - Feb 2023 | Remote',
    bullets: ['Built performance dashboards for ML models using Plotly and Dash during a micro internship.'],
  },
  {
    title: 'Juniata College, Huntingdon PA - Statistical Consultant',
    meta: 'August 2021 - December 2021',
    bullets: ['Displayed strong communication skills while working on a class team project supporting the research of Kathryn M. Westcott, PhD, Psychology.'],
  },
  {
    title: 'Open Farms - Software Engineer Intern',
    meta: 'May 2021 - Aug 2021 | Remote',
    bullets: ['Tested Arduino/esp8266 boards for autonomous farm equipment applications.'],
  },
];

const projects = [
  {
    title: 'Stingray - CEO',
    meta: 'May 2024 - Dec 2024',
    bullets: ['Implemented Proxmox and basic Kubernetes deployments on bare metal servers for seamless AI application deployment.'],
  },
  {
    title: 'Productivity Pangolin - Solo Engineer',
    meta: 'Aug 2020 - May 2024',
    bullets: ['Created a productivity tracking tool using React, Firebase Firestore, and containerized Google Cloud Functions.'],
  },
  {
    title: 'wiki-tui',
    meta: 'Contributor',
    bullets: [
      'Have made PRs that have been merged into the wiki-tui project that lets users view Wikipedia pages from the cli.',
      <>
        Link:{' '}
        <a className="subtle-link" href="https://github.com/Builditluc/wiki-tui" target="_blank" rel="noopener noreferrer">
          https://github.com/Builditluc/wiki-tui
        </a>
      </>,
      'Used Rust and ratatui.',
    ],
  },
  {
    title: 'Penn National Insurance Assistant',
    meta: 'AI Developer',
    bullets: [
      'Made an AI RAG application to help users of Penn National Insurance find the information they needed from the Penn National website.',
      'Used Langchain, and Chroma DB to embed and chunk the text scraped from the website.',
      'Responded to user feedback when adding links to the exact page information was pulled from.',
    ],
  },
];

const Experiance = () => {
  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Experience</div>
          <h1 className="page-title">Work experience & projects</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            A quick overview of roles and projects across product development, infrastructure, and AI-focused software engineering.
          </p>
        </section>

        <section className="section-card">
          <h2 className="section-title">Work experience</h2>
          <div className="item-list">
            {workExperience.map((role) => (
              <div key={role.title} className="item-card">
                <h3 className="item-title">{role.title}</h3>
                <p className="item-meta">{role.meta}</p>
                <ul className="bullet-list">
                  {role.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="section-card">
          <h2 className="section-title">Projects</h2>
          <div className="item-list">
            {projects.map((project) => (
              <div key={project.title} className="item-card">
                <h3 className="item-title">{project.title}</h3>
                <p className="item-meta">{project.meta}</p>
                <ul className="bullet-list">
                  {project.bullets.map((bullet, index) => (
                    <li key={`${project.title}-${index}`}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Experiance;